module.exports = __webpack_public_path__ + "static/assets/fcb487a99425b4a8cc3499b91ef3ce4a.svg";